import { useRouter } from 'next/router';

import { Alert, Box, TextButton } from '@zillow/constellation-10';

import { useAuth } from '../../AuthProvider';
import ConnectedModuleCard from '../../ConnectedModuleCard';

export const WrongAccountAlert = ({
  cardLabel = 'Listing',
  textLabel = 'listing',
}: {
  cardLabel?: string;
  textLabel?: string;
}) => {
  const { user } = useAuth();
  const router = useRouter();

  const signInUrl = `/user/acct/login/?url=${encodeURIComponent(router.asPath)}`;

  return (
    <Box data-testid="DashboardPage-WrongAccountAlert" css={{ marginTop: { base: '200', md: '0' } }}>
      <ConnectedModuleCard title={cardLabel}>
        <Alert
          tone="warning"
          actionButton={
            <TextButton asChild>
              <a href={signInUrl}>Switch accounts</a>
            </TextButton>
          }
        >
          You’re signed in as <span className="fs-mask">{user?.email}</span>. This email isn’t connected to this&nbsp;
          {textLabel}. Sign in with the email address linked to your {textLabel}.
        </Alert>
      </ConnectedModuleCard>
    </Box>
  );
};
